import Vue from 'vue'
import Vuex from 'vuex'
const fb = require('./firebaseConfig.js')

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
      projects: [],
      slides: [
        "/static/slides/4.jpg",
        "/static/slides/slide.jpg",
        "/static/slides/slide_1.jpg",
        "/static/slides/slide_2.jpg",
        "/static/slides/slide_3.jpg",
        "/static/slides/slide_4.jpg",
        "/static/slides/slide_5.jpg",
        "/static/slides/slide_6.jpg",
      ]
    },
    mutations: {
      getProjects() {

      }
    }
})



// WEBPACK FOOTER //
// ./src/store.js